import {
  FileText, Linkedin, Compass, Mic, Users, Layers, Briefcase, Target,
  UserPlus, Sparkles, Eye, Award, Cpu, HeartPulse, Factory,
  Landmark, Rocket, Fingerprint, ClipboardList, Wallet,
} from "lucide-react";

// ---- Brand ----
export const BRAND = {
  name: "North Cadence",
  tagline: "The Rhythm Of A Career, Intentionally Built.",
  logo: "/NC_logo_04.png",
  logoLight: "/NC_logo_03.png",
  navy: "#142A5E",
  green: "#2FA86A",
  seashell: "#FEF7F2",
  // Update these to real values anytime
  whatsapp: "917208227302",
  whatsappMessage:
    "Hello North Cadence,\n\nI'm interested in your services.\nPlease contact me.\n\nThank you.",
  phone: "+91 7208227302",
  email: "info@northcadence.net",
  locations: ["Bengaluru", "Mumbai", "Vadodara"],
  social: {
    linkedin: "https://www.linkedin.com/company/north-cadence/",
    instagram: "https://www.instagram.com/north_cadence?igsh=MTRvdWp0YWphcjBhMw==",
    facebook: "https://www.facebook.com/share/1LHBGZsf9s/?mibextid=wwXIfr",
  },
  // hours: "Mon – Sat · 9:30 AM – 7:00 PM IST",
  // mapEmbed:
  //   "https://www.google.com/maps?q=10405%20Nikoo%20Homes%201%2C%20Bhartiya%20City%2C%20Thanisandra%20Main%20Road%2C%20Bengaluru&output=embed",
};

export const IMAGES = {
  heroOffice: "/NC_about.png",
  team: "/NC_hero_section.png",
};

// ---- Career services (professionals) — primary track, 7 services ----
export const CAREER_SERVICES = [
  {
    icon: FileText,
    category: "professional",
    title: "Resume Writing",
    desc: "ATS-ready resumes that get you past the bots and in front of the right people.",
    slug: "resume-writing",
    delivery: "7–10 business days from brief call",
    bullets: [
      "ATS-optimised formatting calibrated to your target role and seniority level",
      "Impact-driven bullet points: metrics, scope, and outcomes — not job responsibilities",
      "Role-specific versions for different targets within your search",
      "Researched against your actual target job descriptions — not a generic template",
      "Written by professionals who have screened candidates at operational scale",
    ],
  },
  {
    icon: Linkedin,
    category: "professional",
    title: "LinkedIn Optimisation",
    desc: "A magnetic profile that makes recruiters come to you.",
    slug: "linkedin-optimisation",
    delivery: "5–7 business days",
    bullets: [
      "Keyword-rich headline and about section written for your exact target role",
      "Experience section rewritten to align with and amplify your resume narrative",
      "Skills, endorsements, and featured section optimised for recruiter search visibility",
      "Recruiter visibility audit — understand where your profile currently ranks in searches",
      "Content and network growth strategy for sustained visibility beyond the initial build",
    ],
  },
  {
    icon: Mic,
    category: "professional",
    title: "Interview Coaching",
    desc: "Role-specific mock interviews that turn nerves into confidence.",
    slug: "interview-coaching",
    delivery: "One-time intensive or ongoing multi-session series",
    bullets: [
      "Role-specific mock interviews modelled on real processes in your target sector",
      "STAR-based frameworks for every behavioural question type",
      "Technical and case interview preparation for specialised roles",
      "Salary negotiation scripts, offer evaluation, and counter-offer strategy",
      "Written feedback after every session — specific and actionable, not generic notes",
    ],
  },
  {
    icon: Compass,
    category: "professional",
    title: "Career Roadmap",
    desc: "A personalised strategy for where you want to go — with a realistic plan to get there.",
    slug: "career-roadmap",
    delivery: "Most valuable for pivots, promotions, returns, and anyone feeling stuck",
    bullets: [
      "Target role identification and honest market reality check",
      "Skill and experience gap analysis mapped to your specific target level",
      "Personalised 90-day action plan and 2-year career roadmap",
      "Narrative strategy: how to tell your story for the role you want, not the role you've had",
      "Accountability check-ins and quarterly milestone reviews",
    ],
  },
  {
    icon: Rocket,
    category: "professional",
    title: "Career Transition Programme",
    desc: "A complete, end-to-end programme for professionals making a deliberate career move — from clarity to offer.",
    slug: "career-transition-programme",
    delivery: "8 structured weeks, with ongoing support throughout the active search",
    bullets: [
      "Week 1–2: Transition Clarity — target identification, transferable skills mapping, gap analysis",
      "Week 3–4: Story & Assets — career narrative, resume, LinkedIn, and personal brand rebuilt for the new direction",
      "Week 5–6: Search Strategy — target company list, outreach playbook, referral activation, application pipeline",
      "Week 7–8: Interview & Offer — role-specific coaching, mock interviews, salary benchmarking, offer negotiation",
      "Ongoing: weekly check-ins, pipeline reviews, and accountability throughout the active search",
    ],
  },
  {
    icon: Sparkles,
    category: "professional",
    title: "Personal Branding",
    desc: "Own your professional narrative across LinkedIn, your resume, your bio, and every touchpoint where you show up.",
    slug: "personal-branding",
    delivery: "Scoped to your goals during the discovery call",
    bullets: [
      "Brand positioning statement and professional identity development",
      "Consistent voice and messaging across all professional surfaces",
      "Thought leadership and content strategy for LinkedIn visibility",
      "Bio writing for speaker profiles, company pages, and professional introductions",
    ],
  },
  {
    icon: Target,
    category: "professional",
    title: "Job Search Strategy",
    desc: "A targeted, disciplined search built to produce results in weeks — not a scattershot approach to applications.",
    slug: "job-search-strategy",
    delivery: "Monthly retainer with weekly strategy and accountability sessions",
    bullets: [
      "Target company list and ideal-role profile — precision over volume, always",
      "Outreach scripts, referral activation, and recruiter engagement playbooks",
      "Application tracking system and pipeline management approach",
      "Weekly strategy and accountability sessions throughout the active search",
    ],
  },
  // {
  //   icon: UserPlus,
  //   category: "organisation",
  //   title: "Recruitment",
  //   desc: "Full-cycle hiring that finds people who genuinely fit.",
  //   slug: "recruitment",
  //   delivery: "Scoped per engagement — contact us to discuss timelines",
  //   bullets: [
  //     "Role definition and job architecture support before sourcing begins",
  //     "End-to-end sourcing, screening, and structured shortlisting",
  //     "Curated candidate presentations with context and fit reasoning, not just CVs",
  //     "Interview coordination and structured feedback facilitation",
  //     "Offer management and post-placement check-ins to support retention",
  //   ],
  // },
  // {
  //   icon: Layers,
  //   category: "organisation",
  //   title: "RPO Services",
  //   desc: "Your embedded hiring engine — built around your velocity and goals.",
  //   slug: "rpo-services",
  //   delivery: "Flexible engagement models: project-based or ongoing retainer",
  //   bullets: [
  //     "Dedicated team embedded into your hiring process and brand",
  //     "Scalable to match your headcount plan and pipeline velocity",
  //     "Full pipeline reporting, SLA management, and performance analytics",
  //     "Reduces cost-per-hire over time and builds institutional hiring knowledge",
  //   ],
  // },
  // {
  //   icon: Users,
  //   category: "organisation",
  //   title: "Talent Acquisition",
  //   desc: "Proactive sourcing pipelines for the roles that matter most.",
  //   slug: "talent-acquisition",
  //   delivery: "Ongoing engagement for critical and hard-to-fill roles",
  //   bullets: [
  //     "Market mapping and passive candidate identification",
  //     "Outreach and engagement strategies for non-active candidates",
  //     "Employer branding advisory to strengthen your talent attraction",
  //     "Pipeline development for current and future critical roles",
  //   ],
  // },
  // {
  //   icon: Briefcase,
  //   category: "organisation",
  //   title: "Business Development & Lead Generation",
  //   desc: "Open markets, build pipelines, and convert relationships into revenue.",
  //   slug: "business-development-lead-generation",
  //   delivery: "Scoped per engagement — contact us to discuss timelines",
  //   bullets: [
  //     "Market entry strategy, opportunity mapping, and competitive positioning",
  //     "Partnership programme design and partner identification",
  //     "Ideal customer profile (ICP) definition and audience segmentation",
  //     "Outbound sequence design across email, LinkedIn, and relevant channels",
  //   ],
  // },
];

// Kept as an alias — several homepage sections import SERVICES
export const SERVICES = CAREER_SERVICES;

// ---- Career packages ----
export const CAREER_PACKAGES = [
  {
    icon: Compass,
    title: "The Essentials",
    desc: "Resume Writing + LinkedIn Optimisation — for professionals who need polished assets before they apply.",
    meta: "Delivery: 2–3 weeks",
  },
  {
    icon: Sparkles,
    title: "The Full Rebrand",
    desc: "Resume + LinkedIn + Personal Branding — for professionals ready to own their narrative end to end.",
    meta: "Best for career movers and senior professionals",
  },
  {
    icon: Mic,
    title: "The Career Accelerator",
    desc: "Career Roadmap + Resume + LinkedIn + Interview Coaching — for professionals serious about their next move.",
    meta: "Prepared for every stage",
  },
  {
    icon: Rocket,
    title: "Career Transition Programme",
    desc: "The complete end-to-end programme for professionals making a deliberate career change — from clarity to offer.",
    meta: "8 weeks with ongoing support",
  },
];

// ---- Organisational services — secondary track, 6 services ----
export const ORG_SERVICES = [
  {
    icon: UserPlus,
    title: "Recruitment",
    desc: "Full-cycle hiring that finds people who genuinely fit.",
    long: "We manage the complete hiring process — from role definition and sourcing through to shortlisting, interview coordination, offer management, and post-placement follow-up. You receive a curated shortlist of candidates who are evaluated for role fit, culture alignment, and motivation — not just screened against a job description.",
    bullets: [
      "Role definition and job architecture support before sourcing begins",
      "End-to-end sourcing, screening, and structured shortlisting",
      "Curated candidate presentations with context and fit reasoning, not just CVs",
      "Interview coordination and structured feedback facilitation",
      "Offer management and post-placement check-ins to support retention",
    ],
  },
  {
    icon: Layers,
    title: "RPO Services",
    desc: "Your embedded hiring engine — built around your velocity and goals.",
    long: "In an RPO engagement, our team acts as your embedded recruitment function — operating under your brand, within your processes, and at the hiring velocity your business demands. Designed for organisations that need to hire at scale or speed without building a large internal team. Fully transparent: you see the pipeline, the activity, and the outcomes at every stage.",
    bullets: [
      "Dedicated team embedded into your hiring process and brand",
      "Scalable to match your headcount plan and pipeline velocity",
      "Full pipeline reporting, SLA management, and performance analytics",
      "Reduces cost-per-hire over time and builds institutional hiring knowledge",
      "Flexible engagement models: project-based or ongoing retainer",
    ],
  },
  {
    icon: Users,
    title: "Talent Acquisition",
    desc: "Proactive sourcing pipelines for the roles that matter most.",
    long: "Talent acquisition is distinct from reactive recruitment. We proactively build pipelines for critical, niche, and hard-to-fill roles — mapping the market, engaging passive candidates, and developing employer brand positioning that attracts the right profiles. The right approach for senior hires, specialist roles, and positions where posting a job description is not enough.",
    bullets: [
      "Market mapping and passive candidate identification",
      "Outreach and engagement strategies for non-active candidates",
      "Employer branding advisory to strengthen your talent attraction",
      "Pipeline development for current and future critical roles",
      "Specialised capability for technology, healthcare, and product leadership hires",
    ],
  },
  {
    icon: Briefcase,
    title: "Business Development & Lead Generation",
    desc: "Open markets, build pipelines, and convert relationships into revenue.",
    long: "We help organisations build the sales pipelines, partnerships, and outbound capability that produce sustainable revenue growth. This service combines market development strategy with hands-on lead generation execution — so you get both the plan and the pipeline, not one without the other. Suited to early and growth-stage B2B organisations looking to accelerate revenue without yet having a full sales team in place.",
    bullets: [
      "Market entry strategy, opportunity mapping, and competitive positioning",
      "Partnership programme design and partner identification",
      "Ideal customer profile (ICP) definition and audience segmentation",
      "Outbound sequence design across email, LinkedIn, and relevant channels",
      "Qualified lead delivery with context and fit notes for your sales team",
      "Revenue growth planning with execution milestones and pipeline tracking",
    ],
  },
  {
    icon: ClipboardList,
    title: "Hiring Strategy & Workforce Planning",
    desc: "Build a deliberate hiring process and a team structure built to scale.",
    long: "This combined engagement covers two interconnected challenges: how you hire and how you plan the team around it. We help organisations design the hiring frameworks, scorecards, and processes that make every hire consistent and strategic — and then connect those decisions to a broader workforce plan that maps current capability against future growth needs. Most valuable for organisations scaling rapidly, professionalising their people function, or preparing for the next phase of headcount growth.",
    bullets: [
      "Job architecture, role levelling, and competency framework design",
      "Interview scorecard design calibrated to each role's specific requirements",
      "Structured hiring process design for consistency, fairness, and repeatability",
      "Current-state capability assessment and skills gap analysis",
      "Future-state team structure modelling aligned to business milestones",
      "Headcount planning, hiring prioritisation, and succession risk mapping",
    ],
  },
  {
    icon: Wallet,
    title: "HR & Payroll",
    desc: "The people infrastructure that keeps your organisation compliant, paid, and running.",
    long: "We help organisations set up and manage the HR and payroll foundations that growing teams need — from onboarding and policy frameworks to payroll administration and compliance. Whether you're a startup formalising your people function for the first time or a growing SME looking to outsource HR operations, we provide the structure and support to keep things right.",
    bullets: [
      "HR policy framework design and employee handbook development",
      "Onboarding process design and documentation",
      "Payroll administration and compliance support",
      "Leave, attendance, and statutory compliance management",
      "Suited to startups and SMEs formalising or outsourcing their HR and payroll function",
    ],
  },
];

export const WHY = [
  { icon: Fingerprint, title: "Our team has been on the hiring side", desc: "Our founders have sourced, screened, placed, and managed candidate pipelines at scale across global markets — informing every resume, profile, and interview we coach." },
  { icon: Sparkles, title: "Nothing generic, ever", desc: "No templates, no copy-paste, no AI-generated filler. Every engagement is built specifically for your target role, level, and industry." },
  { icon: Layers, title: "Resume + LinkedIn + Brand — one system", desc: "We build your career assets to work together, saying the same thing with the same force — because disconnected assets lose opportunities." },
  { icon: Rocket, title: "A complete programme for career transitions", desc: "Most services help you polish what you have. Our Career Transition Programme is full strategy, full execution — from clarity to offer." },
  { icon: Eye, title: "Transparent, honest, pressure-free", desc: "Clear timelines, upfront pricing, no upselling. If something won't move the needle, we'll tell you — even if it means a smaller scope." },
  { icon: Award, title: "A new firm with a compelling reason to exist", desc: "Being new means you get the founding team's full attention and their genuine investment in building a reputation on your outcome." },
];

export const PROCESS = [
  { n: "01", title: "Free Discovery Call", desc: "A 30-minute call with our senior leadership — no pitch, no pressure. We listen, ask the right questions, and recommend the right starting point." },
  { n: "02", title: "Career Strategy Session", desc: "We map your roadmap: target roles, narrative gaps, assets to build, and the specific sequence that will move you fastest." },
  { n: "03", title: "Build & Coach", desc: "We build your resume, LinkedIn profile, and personal brand — then coach you through applications, interviews, and offer negotiation." },
  { n: "04", title: "Offer & Beyond", desc: "We stay through the offer stage — help you evaluate, negotiate, and set up the foundation for the chapter after this one." },
];

export const MANIFESTO = [
  { n: "01", title: "Clients first, always.", desc: "Every strategy we build starts with the client — their ambitions, their constraints, their specific situation. We do not fit clients into frameworks. We build frameworks around clients." },
  { n: "02", title: "A career is a narrative, not a list of jobs.", desc: "Hiring managers read a career as a story. The professionals who advance fastest are the ones whose story is coherent, intentional, and pointing clearly in one direction." },
  { n: "03", title: "Transitions deserve a complete programme, not a polished CV.", desc: "A career switch is a strategy problem, a narrative problem, an execution problem, and a confidence problem — all at once. Our Career Transition Programme addresses all of them, in sequence." },
  { n: "04", title: "Cadence beats intensity.", desc: "Growth is not a sprint — for careers or for companies. It is a rhythm: steady, repeatable actions that compound over time. We design for that discipline." },
  { n: "05", title: "Honesty over comfort.", desc: "We will tell you if your resume is the problem, if your target is unrealistic, if a candidate isn't the right fit. Honest feedback, delivered with care, is what moves things forward." },
  { n: "06", title: "Both sides of the table.", desc: "We work with professionals and with the organisations that hire them. That dual perspective is structural — and it goes into every piece of work we produce." },
  { n: "07", title: "Earn trust, don't claim it.", desc: "We are a new firm. We will not inflate our credentials or fabricate social proof. We build our reputation the only way that holds: one result at a time." },
  { n: "08", title: "Precision over volume.", desc: "One well-targeted application beats a hundred scattershot ones, and one right hire beats five fast ones. Every piece of work we produce is precise." },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Years combined experience" },
  { value: 96, suffix: "%", label: "Client satisfaction" },
  { value: 6, suffix: "", label: "Organisational service areas" },
  { value: 7, suffix: "", label: "Career services for professionals" },
];

export const CREDIBILITY = [
  // { label: "20+ years", desc: "of combined professional experience across enterprise sales, IT staffing and consulting, and product leadership" },
  { label: "Hundreds of placements", desc: "facilitated across US and India markets through hands-on IT staffing and consulting operations" },
  { label: "Global accounts", desc: "managed across US, India, and international markets — professionals placed and teams built at enterprise scale" },
  { label: "Cross-industry depth", desc: "experience spanning technology, healthcare, financial services, manufacturing, and professional services" },
  // { label: "Both sides of the table", desc: "careers built and teams hired — our founders have screened, placed, coached, and led hiring at scale" },
  // { label: "Active in AI", desc: "current hands-on enterprise AI product development — our technology practice is grounded in what is happening now" },
];

export const WHAT_TO_EXPECT = [
  { title: "Your first call is with senior leadership.", desc: "Not a salesperson. Not a scheduler. Every discovery call is taken by a member of the founding team — who listens to your situation, asks the questions that matter, and gives you an honest assessment of what will actually help. If we're not the right fit, we'll tell you." },
  { title: "Your resume will be researched, not recycled.", desc: "Before we write a word, we study your target job descriptions, extract the language hiring managers use, and map your experience to what they're actually looking for. The result reads like it was written for that specific role — because it was." },
  { title: "You'll know the plan before you pay for it.", desc: "Every engagement begins with a clear scope, timeline, and cost. No surprises mid-engagement. No upselling once work has started. You approve the direction before we execute." },
  { title: "We stay until the work is right.", desc: "Every engagement includes defined revision rounds and we revise until the output genuinely meets the brief. If we've missed the mark on strategy or direction, we make it right — not just make it look different." },
];

export const INDUSTRIES = [
  { icon: Cpu, name: "Technology" },
  { icon: HeartPulse, name: "Healthcare" },
  { icon: Factory, name: "Manufacturing" },
  { icon: Landmark, name: "Financial Services" },
  { icon: Briefcase, name: "Professional Services" },
];

export const FAQ_GROUPS = [
  {
    group: "About North Cadence",
    items: [
      { q: "You're a new firm. Why should I trust you with something this important?", a: "That's the right question, and it deserves a direct answer. We are new as a firm — but the experience behind it is not. Our founding team brings 20+ years of combined experience across global enterprise sales, IT staffing and consulting operations, and healthcare SaaS product leadership. One co-founder has managed large candidate placement portfolios across US and India markets. The other has built enterprise products from zero to commercial scale. What we don't have yet are client testimonials from North Cadence engagements — and we won't fabricate them. What we offer instead is founding team attention, a genuine commitment to your outcome, and honest pricing that reflects where we are." },
      { q: "Do you have client testimonials?", a: "Not yet — and we're not going to invent them. North Cadence is a new firm and we are building our client story with every engagement we take on. Our first clients will be the ones who believe in what we're building, and our reputation will grow from what we produce for them." },
      { q: "Who will I speak to first?", a: "Every discovery call is taken by a member of our senior leadership team. You will not speak to a salesperson or a junior intake coordinator. Our founding team takes every first conversation personally." },
      { q: "Who is North Cadence for?", a: "We serve two client groups. First and primarily: individual professionals — job seekers, working professionals, career switchers, students, and career returners. Second: organisations — startups, SMEs, and growing companies seeking to hire, build teams, or grow revenue. Both practices are led by the same founding team with the same commitment to outcomes over deliverables." },
    ],
  },
  {
    group: "Career Services — For Professionals",
    items: [
      { q: "What is the Career Transition Programme and who is it for?", a: "It is our most comprehensive career service — a structured 8-week programme for professionals making a deliberate career move. It covers everything: transition clarity and target identification (weeks 1–2), career assets rebuilt for the new direction (weeks 3–4), job search strategy design (weeks 5–6), and interview and offer coaching (weeks 7–8), with weekly accountability check-ins throughout the active search. It's designed for career switchers, professionals returning after a break, and anyone ready for a genuine step-change rather than just a new role within the same lane." },
      { q: "How is the Career Transition Programme different from buying the services individually?", a: "The individual services address specific components. The Career Transition Programme is the complete journey — it starts with clarity about where you actually want to go, builds everything you need to get there, designs the search, and supports you through every stage until you have an offer. The sequencing matters: each phase is built on the previous one, which is why the programme produces results that the individual services in isolation cannot." },
      { q: "What is included in a resume writing engagement?", a: "We begin with a written brief and a 30–45 minute call to understand your target role, level, industry, and what hasn't been working. We research your target job descriptions, extract the language hiring managers actually use, and write a resume that speaks directly to it. You receive one polished, fully formatted resume and one round of revisions. Additional role-specific versions are available. Delivery is 7–10 business days from the brief call." },
      { q: "What does LinkedIn optimisation involve?", a: "We rewrite your headline, about section, and experience entries; optimise your skills and endorsements; advise on your featured section; and give you a keyword strategy mapped to your target roles. We run a recruiter visibility audit so you understand where your profile currently sits in relevant searches. Profile goes live within 5–7 business days. A content and network growth strategy is available as an add-on." },
      { q: "How is your interview coaching different from practising with a friend?", a: "Friends give you comfort. We give you calibrated, specific feedback grounded in how real hiring processes in your target sector work. You receive written notes after each session, STAR-based frameworks for every behavioural question type, and preparation for technical or case components where relevant. We also cover salary negotiation and offer evaluation — stages most professionals are least prepared for, and where the difference between getting the offer and the right offer is made." },
      { q: "Can you help me switch careers into a completely different field?", a: "Yes — and it's one of the areas we're specifically built for. The challenge is always narrative: making your existing experience feel relevant to a hiring manager who has never seen your background before. Our Career Transition Programme, Career Roadmap, Personal Branding, and Resume Writing services all address this directly. Tell us where you're coming from and where you want to go — we'll give you an honest assessment of the path." },
      { q: "Do you work with students and recent graduates?", a: "Yes. We work with final-year students and recent graduates building their first professional foundation — resume, LinkedIn profile, and a targeted job search strategy. These engagements are scoped and priced appropriately for early-career clients." },
      { q: "I've been out of the workforce for a period. Can you help me re-enter?", a: "Yes. Re-entry is a specific situation we handle well. The challenge is framing: how to position a career break honestly, surface what you were doing during it, and present your experience for a market that has moved on. We treat a career break as an asset to be framed — not a gap to be hidden." },
    ],
  },
  {
    group: "Working With Us",
    items: [
      { q: "How long do engagements take?", a: "Resume writing: 7–10 business days from brief call. LinkedIn optimisation: 5–7 business days. Career Roadmap: 2–3 weeks for the initial document. Interview coaching: booked on a rolling basis. Job Search Strategy: monthly retainer with weekly sessions. Career Transition Programme: 8 structured weeks with ongoing support. All timelines are confirmed at the end of the discovery call." },
      { q: "How much do your services cost?", a: "We don't publish a fixed price list because scope varies between clients. What we can tell you is that pricing is fully transparent — you receive a clear quote before any work begins, with no hidden fees or mid-engagement changes. Our pricing reflects both the quality of the work and where we are as a new firm. Book a discovery call and we'll give you a quote within 24 hours." },
      { q: "What if I'm not satisfied?", a: "Every engagement includes defined revision rounds, and we revise until the output genuinely meets the brief. If we've missed the mark on strategy or direction, we make it right — not just make it look different. We are building our reputation on results." },
      { q: "Do you work remotely?", a: "Yes — all services are delivered remotely via video calls, shared documents, and async tools. In-person meetings are available for clients based in Bengaluru or Ahmedabad." },
    ],
  },
  {
    group: "For Organisations",
    items: [
      { q: "What organisational services does North Cadence offer?", a: "Our organisational practice covers six service areas: recruitment, RPO, talent acquisition, business development & lead generation, hiring strategy & workforce planning, and HR & payroll. Each service is described in full on our Services page. All organisational enquiries are handled by our founding team — reach out and we'll recommend the right starting point for your situation." },
      { q: "Can a company and one of its employees both engage North Cadence?", a: "Yes — and we manage this with explicit confidentiality boundaries. An organisation engaging us on recruitment and a professional from that organisation engaging us on career services are treated as fully separate engagements. No information flows between them without explicit written consent from both parties." },
    ],
  },
];

// Flat list used for the homepage FAQ preview / accordion
export const FAQS = FAQ_GROUPS.flatMap((g) => g.items);

export const FOUNDERS = [
  {
    name: "Kesha Desai",
    role: "Co-Founder & Executive Lead",
    location: "Bengaluru",
    linkedin: "https://www.linkedin.com/in/keshadesai",
    bio: "Kesha brings over 12 years of global experience across enterprise software sales, account management, and IT staffing and consulting — spanning markets across the US, India, and internationally. Her career has not been confined to a single domain or industry. Moving deliberately across enterprise automation, RPA, AI, cloud solutions, and staffing, she has built progressive commercial expertise across sectors — giving her a rare ability to see what career growth looks like across different industries, what actually transfers between domains, and how hiring decisions are made on the employer side.",
    bioExtra: "Having built her own career across organisations of varying sizes, cultures, and geographies, Kesha understands what career growth looks like from the inside — the pivots, the accelerations, and the moments where precise positioning made the difference. Over the years she has built a wide, active international network across the markets she has worked in: not a list of contacts, but genuine relationships cultivated across global accounts, cross-functional teams, and diverse client portfolios that now give North Cadence both reach and live market intelligence.",
    handles: "At North Cadence, Kesha works directly with professionals who are building, pivoting, or accelerating their careers — and with organisations looking to hire, grow, and build teams that last. Her ability to understand both perspectives in the same conversation is what makes that work effective.",
  },
  {
    name: "Dr. Abhishek Gandhi",
    role: "Co-Founder & Executive Lead",
    location: "Bengaluru",
    linkedin: "https://www.linkedin.com/in/dr-abhishek-gandhi",
    bio: "Abhishek brings over a decade of experience in enterprise product leadership — building complex SaaS platforms from concept to commercial scale, leading large cross-functional product and engineering teams, and working across cloud, enterprise software, and AI product environments. His work has spanned the US healthcare space, where he has navigated the intersection of clinical domain knowledge, regulatory complexity, and technology execution.",
    bioExtra: "His own career is a story of deliberate reinvention — from clinical practice to product strategy and technology leadership, built through intent, persistence, and a willingness to grow in a domain that was not his primary one. He knows what it takes to be taken seriously in a field you did not start in, to build credibility from scratch, and to turn an unconventional background into a genuine professional advantage. That is not something he advises on from a distance — it is something he has lived.",
    handles: "Having built and led teams himself, he understands how a hiring manager actually thinks — what makes a candidate stand out for a specialised role, what gets lost in translation between a niche profile and a standard screening process, and where the real gaps between great talent and great opportunity tend to sit. At North Cadence, he brings that depth to engagements where domain knowledge, product thinking, and a genuine understanding of how teams are built make a meaningful difference.",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Why NC?", to: "/manifesto" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_OPTIONS = [
  "Resume Writing", "LinkedIn Optimisation", "Interview Coaching", "Career Roadmap",
  "Career Transition Programme", "Personal Branding", "Job Search Strategy",
  "Recruitment", "RPO Services", "Talent Acquisition", "Business Development & Lead Generation",
  "Hiring Strategy & Workforce Planning", "HR & Payroll", "Other",
];
